'use strict';

module.exports = require('./_source/linked-list.js');



//////////////////
// WEBPACK FOOTER
// ./~/linked-list/index.js
// module id = 1005
// module chunks = 30 31 32